// API Configuration
// Centralized API base URL configuration with environment support

import { getCurrentEnvironment } from './environments';

// Get environment-specific configuration
const envConfig = getCurrentEnvironment();

// Runtime environment detection for API endpoint selection
const getApiBaseUrl = () => {
  // In local development mode (npm start), use proxy
  if (process.env.NODE_ENV === 'development' && !process.env.REACT_APP_ENV) {
    return ''; // Use proxy for local development
  }
  
  // For built environments, use environment-specific API URLs
  return envConfig.apiBaseUrl;
};

const API_BASE_URL = getApiBaseUrl();

// Export environment configuration for use throughout the app
export { 
  API_BASE_URL,
  envConfig as environmentConfig
};